import firebase from '../../../config/firebase';

const database = firebase.database();


export function getTheme(callback) {
  database.ref('theme').on('value', function(snapshot) {
    const theme = snapshot.val();
    callback(true, theme, null);
  });
}

export function editTheme (data, callback) {
  database.ref('theme').update(data, function(error) {
    if (error) {
      callback(false, null, error);
    } else {
      callback(true, data, null);
    }
  });
}
